import { Component } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';

@Component({
  selector: 'lib-form-heading',
  styleUrls: ['form-heading.component.scss'],
  templateUrl: 'form-heading.component.html',
  imports: [FormsModule, ReactiveFormsModule],
})
export class FormHeadingComponent extends FieldBaseComponent {}
